module.exports = __webpack_public_path__ + "img/撇嘴.eab545a2.gif";